/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Select_List_LabelInputs */

const en_markers_select_list_label = /** @type {(inputs: Markers_Select_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select marker list`)
};

const fr_markers_select_list_label = /** @type {(inputs: Markers_Select_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner la liste de marqueurs`)
};

const de_markers_select_list_label = /** @type {(inputs: Markers_Select_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markerliste auswählen`)
};

const it_markers_select_list_label = /** @type {(inputs: Markers_Select_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona l'elenco dei marcatori`)
};

const ru_markers_select_list_label = /** @type {(inputs: Markers_Select_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите список маркеров`)
};

const es_markers_select_list_label = /** @type {(inputs: Markers_Select_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar lista de marcadores`)
};

const zh_cn2_markers_select_list_label = /** @type {(inputs: Markers_Select_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择标记列表`)
};

const ja_markers_select_list_label = /** @type {(inputs: Markers_Select_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーリストを選択`)
};

const hi_markers_select_list_label = /** @type {(inputs: Markers_Select_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर सूची का चयन करें`)
};

const pt_pt2_markers_select_list_label = /** @type {(inputs: Markers_Select_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de marcadores selecionada`)
};

/**
* | output |
* | --- |
* | "Select marker list" |
*
* @param {Markers_Select_List_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_select_list_label = /** @type {((inputs?: Markers_Select_List_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Select_List_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_select_list_label(inputs)
	if (locale === "de") return de_markers_select_list_label(inputs)
	if (locale === "it") return it_markers_select_list_label(inputs)
	if (locale === "ru") return ru_markers_select_list_label(inputs)
	if (locale === "es") return es_markers_select_list_label(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_select_list_label(inputs)
	if (locale === "ja") return ja_markers_select_list_label(inputs)
	if (locale === "hi") return hi_markers_select_list_label(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_select_list_label(inputs)
	return en_markers_select_list_label(inputs)
});